var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestRejected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 13.6667C3.31801 13.6667 0.333344 10.682 0.333344 7.00004C0.333344 3.31804 3.31801 0.333374 7.00001 0.333374C10.682 0.333374 13.6667 3.31804 13.6667 7.00004C13.6667 10.682 10.682 13.6667 7.00001 13.6667ZM7.00001 6.05737L5.11468 4.17137L4.17134 5.11471L6.05734 7.00004L4.17134 8.88537L5.11468 9.82871L7.00001 7.94271L8.88534 9.82871L9.82868 8.88537L7.94268 7.00004L9.82868 5.11471L8.88534 4.17137L7.00001 6.05737Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestRejected);
export default __webpack_public_path__ + "static/media/request-rejected.a322dd8f4c17c671688b2e3b34f000cb.svg";
export { ForwardRef as ReactComponent };